import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
	GetReportList({ commit }, list) {
		return new Promise(resolve => {
			axios({
				url: "/log/report",
				params: {
					start_time: list.start_time || null,
					end_time: list.end_time || null,
					from: list.page || 0,
					count: list.per_page || 10,
					vendor_id: list.vendor_id || null,
					company_name: list.company_name || null,
					dnis_prefix: list.dnis_prefix || null,
					ani: list.ani || null,
					fields: list.fields || [],
					group: list.group || [],
					step: list.step || 'all'
				},
				method: "GET"
			}).then(res => {
				resolve(res.data);
			});
		});
	},
};

// mutations
const mutations = {};

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations
};
